export const RouteNames = {
    AcceptInvite: 'accept-invite',
    ChangePassword: 'change-password',
    ForgotPassword: 'forgot-password',
    ResetPassword: 'reset-password',
    VerifyEmail: 'verify-email',
    Home: 'home',
    AdminHome: 'admin-home',
    AdminAiUsage: 'admin-ai-usage',
    AdminSupportInbox: 'admin-support-inbox',
    AdminSupportConversation: 'admin-support-conversation',
    AdminSupportFeedback: 'admin-support-feedback',
    AdminSupportHandoffs: 'admin-support-handoffs',
    AdminAiUsageUser: 'admin-ai-usage-user',
    AdminSubscriptionInvoices: 'admin-subscription-invoices',
    Login: 'login',
    SignUp: 'signup',
    MediaViewer: 'media-viewer',
    Profile: 'profile',
    Users: 'users',
    UsersDetail: 'user-detail',
    UsersCreate: 'user-create',
    Companies: 'companies',
    CompanyView: 'company-view',
    CompanyDetail: 'company-detail',
    CompanyCreate: 'company-create',
    Customers: 'customers',
    CustomerView: 'customer-view',
    CustomerDetail: 'customer-detail',
    CustomerCreate: 'customer-create',
    Config: 'config',
    ConfigDetail: 'config-detail',
    ConfigCreate: 'config-create',
    Invoices: 'invoices',
    InvoiceDetail: 'invoice-detail',
    InvoiceView: 'invoice-view',
    InvoicePublicView: 'invoice-public-view',
    CreditNoteView: 'credit-note-view',
    CreditNotePublicView: 'credit-note-public-view',
    ViewPdf: 'view-pdf',
    InvoiceCreate: 'invoice-create',
    Quotes: 'quotes',
    QuoteDetail: 'quote-detail',
    QuoteView: 'quote-view',
    QuoteCreate: 'quote-create',
    QuotePublicView: 'quote-public-view',
    NotFound: 'not-found',
    ServerError: 'server-error',
    Settings: 'settings',
    SettingsGeneral: 'settings-general',
    SettingsPayments: 'settings-payments',
    SettingsCompanies: 'settings-companies',
    SettingsCompany: 'settings-company',
    SettingsCompanyCreate: 'settings-company-create',
    SettingsCompanyDetail: 'settings-company-detail',
    SettingsCompanyView: 'settings-company-view',
    SettingsUsers: 'settings-users',
    SettingsBranding: 'settings-branding',
    SettingsSecurity: 'settings-security',
    SettingsApiTokens: 'settings-api-tokens',
    Billing: 'billing',
    BillingReturn: 'billing-return',
    PaymentStatus: 'payment-status',
    ConnectTelegram: 'connect-telegram',
    ConnectWhatsApp: 'connect-whatsapp',
    ConnectSignal: 'connect-signal',
    TwoFactorVerify: 'two-factor-verify',
    Catalog: 'catalog',
    CustomerGroups: 'customer-groups',
    CustomerGroupCreate: 'customer-group-create',
    CustomerGroupDetail: 'customer-group-detail',
    Projects: 'projects',
    ProjectCreate: 'project-create',
    ProjectDetail: 'project-detail',
    TimeEntries: 'time-entries',
    TimeEntryCreate: 'time-entry-create',
    TimeEntryDetail: 'time-entry-detail',
    TimeEntryReports: 'time-entry-reports',
    RecurringInvoices: 'recurring-invoices',
    RecurringInvoiceCreate: 'recurring-invoice-create',
    RecurringInvoiceDetail: 'recurring-invoice-detail',
    RecurringInvoiceEdit: 'recurring-invoice-edit',
};

export const NavBarGroups = {
    Media: 'media',
    Users: 'users',
    Companies: 'companies',
    Customers: 'customers',
    Invoices: 'invoices',
    Quotes: 'quotes',
    Settings: 'settings',
    Config: 'config',
};
